---
title: 'Step 3: Install the Collector'
install_track_title: Installation Guide (Amazon RDS and Amazon Aurora)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import SetupIAMPolicy from './_03_setup_iam_policy.mdx';

## Installing the collector with Amazon ECS

We will launch this container as a single persistent task using an [ECS service](https://docs.aws.amazon.com/AmazonECS/latest/userguide/ecs_services.html), with secrets [stored in SSM parameters](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/specifying-sensitive-data.html).

<SetupIAMPolicy />

### Create IAM role

We'll need a special IAM role to run the container with. The following commands
will create an appropriate role.
This assumes you are using your account's default KMS key for accessing SSM
parameters.

```bash
aws iam create-role --role-name pganalyzeTaskRole \
  --description "pganalyze collector ECS tasks" \
  --assume-role-policy-document '{"Version": "2012-10-17", "Statement": [{"Effect": "Allow", "Principal": {"Service": "ecs-tasks.amazonaws.com"}, "Action": "sts:AssumeRole"}]}'
   
aws iam attach-role-policy --role-name pganalyzeTaskRole \
  --policy-arn arn:aws:iam::aws:policy/service-role/AmazonECSTaskExecutionRolePolicy
   
aws iam put-role-policy --role-name pganalyzeTaskRole \
  --policy-name GetSSMPganalyzeParameters \
  --policy-document '{"Statement":[{"Action": ["ssm:GetParameter", "ssm:GetParameters", "ssm:GetParametersByPath"], "Effect": "Allow", "Resource": "arn:aws:ssm:*:*:parameter/pganalyze/*"}, {"Action": "kms:Decrypt", "Effect": "Allow", "Resource": "arn:aws:kms:*:*:*"}]}'
   
aws iam attach-role-policy --role-name pganalyzeTaskRole \
  --policy-arn arn:aws:iam::YOURAWSACCOUNTID:policy/POLICYNAME
```

Make sure to replace `arn:aws:iam::YOURAWSACCOUNTID:policy/POLICYNAME` with the
correct policy ARN you created earlier.

**Important:** For more complex scenarios you might want to restrict the `kms:Decrypt` permission in the policy statement above to a specific key.

<Link className="btn btn-success" to="04_configure_the_collector_ecs">
  Proceed to Step 4: Configure the Collector
</Link>
